import React from "react";
import { useLenis } from "../hooks/useLenis";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { AppDemo } from "../components/AppDemo";
import { VideoBand } from "../components/VideoBand";
import { PatentChooser } from "../components/PatentChooser";
import { About } from "../components/About";
import { Patent } from "../components/Patent";
import { Showcase } from "../components/Showcase";
import { Gallery } from "../components/Gallery";
import { Capabilities } from "../components/Capabilities";
import { Services } from "../components/Services";
import { Stats } from "../components/Stats";
import { Vision } from "../components/Vision";
import { Sectors } from "../components/Sectors";
import { Testimonials } from "../components/Testimonials";
import { Footer } from "../components/Footer";
import { Seo } from "../components/Seo";

export default function Landing() {
  useLenis();
  return (
    <div className="grain relative">
      <Seo page="home" />
      <div
        className="fixed inset-0 -z-10 pointer-events-none opacity-[0.025]"
        style={{
          backgroundImage:
            "radial-gradient(rgba(217,164,65,0.7) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
          maskImage: "radial-gradient(ellipse 100% 90% at 50% 0%, black, transparent 75%)",
          WebkitMaskImage: "radial-gradient(ellipse 100% 90% at 50% 0%, black, transparent 75%)",
        }}
      />
      <Nav />
      <main>
        <VideoBand />
        <PatentChooser />
        <Hero />
        <AppDemo />
        <Stats />
        <About />
        <Patent />
        <Showcase />
        <Capabilities />
        <Gallery />
        <Services />
        <Vision />
        <Sectors />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}
